<template>
  <div class="route">
    <div class="form-row options">
      <select v-model="isReturnDifferentPlace" class="sml" aria-label="Return to different place">
        <option :value="false">Same drop-off</option>
        <option :value="true">Other drop-off</option>
      </select>
    </div>
    <div class="form-section legs">
      <div v-for="(leg, index) in route" :key="index" class="form-row leg">
        <PlacePicker v-bind="$attrs" v-model:place="leg.placeCollect" :placeholder="'Pick-up place'" @error="$emit('error', $event)" />
        <div class="break" />
        <PlacePicker v-if="isReturnDifferentPlace == true" v-bind="$attrs" v-model:place="leg.placeReturn" :placeholder="'Drop-off place'" :class="'date-picker-return'" @error="$emit('error', $event)" />
        <div v-if="isReturnDifferentPlace" class="break break-return" />
        <div class="datetime datetime-collect">
          <DatePicker v-bind="$attrs" v-model:date="leg.dateCollect" class="date-collect" :placeholder="'Pick-up date'" />
          <div class="break dates" />
          <select v-model="leg.dateCollectTime" class="times">
            <option v-for="t in times" :key="t" :value="t">
              {{ t }}
            </option>
          </select>
        </div>
        <div class="break datetime" />
        <div class="datetime">
          <DatePicker v-bind="$attrs" v-model:date="leg.dateReturn" class="date-return" :min="leg.dateCollect" :placeholder="'Drop-off date'" />
          <div class="break dates" />
          <select v-model="leg.dateReturnTime" class="times">
            <option v-for="t in times" :key="t" :value="t">
              {{ t }}
            </option>
          </select>
          <a v-if="route.length > 1" class="remove" @click="legRemove(index)">&cross;</a>
        </div>
      </div>
      <div class="add">
        <a @click="legAdd">Add Car</a>
      </div>
    </div>
    <div id="navigation">
      <button @click="next">Next Step</button>
      <a @click="back">Back</a>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import DatePicker from "./common/PickerDate.vue";
import PlacePicker from "./common/PickerPlace.vue";

const emit = defineEmits(["error", "back", "update:cars", "update:isSavedRoute", "update:legIndex", "scroll"]);
const props = defineProps(["cars"]);

const isReturnDifferentPlace = ref(false);
const route = ref(props.cars.route);

const times = computed(() => {
  const minutes = ["00", "15", "30", "45"];
  const periods = ["am", "pm"];
  const times = [];
  for (let i = 0; i <= 1; i++) {
    for (let j = 0; j <= 11; j++) {
      for (let k = 0; k < minutes.length; k++) {
        const hour = i == 1 && j == 0 ? 12 : j;
        const time = hour + ":" + minutes[k] + periods[i];
        times.push(time);
      }
    }
  }
  return times;
});

const blank = () => ({
  dateCollect: "",
  dateCollectTime: "12:00pm",
  dateReturn: "",
  dateReturnTime: "12:00pm",
  placeCollect: "",
  placeReturn: "",
});

const back = () => {
  emit("back");
};

const legAdd = () => {
  route.value.push(blank());
};

const legRemove = index => {
  route.value.splice(index, 1);
};

const next = () => {
  let validated = true;
  for (let i = 0; i < route.value.length; i++) {
    if (!route.value[i].placeCollect || !route.value[i].dateCollect || !route.value[i].dateReturn) {
      validated = false;
    }
  }

  if (validated === false) {
    alert("Please select locations and dates for all cars before continuing.");
  } else {
    route.value.forEach(leg => {
      leg.ideal = {};
    });

    const newCars = { ...props.cars, isReturnDifferentPlace: isReturnDifferentPlace.value, route: route.value };

    emit("update:cars", newCars);
    emit("update:isSavedRoute", true);
    emit("update:legIndex", 0);
    emit("scroll");
  }
};
</script>

<style lang="less">
#cars {
  .route {
    clear: both;
  }

  .leg {
    flex-wrap: wrap;
  }

  .picker,
  .datetime,
  .date-picker {
    flex: 1;
  }

  .times {
    width: auto;
  }

  .break {
    flex-basis: 100%;
    height: 0;
  }

  .remove {
    background: none;
    border: none;
    padding: 1rem 0;
    text-align: right;
    width: 2rem;
  }
}

@media screen and (min-width: 22.5em) {
  #cars {
    .date-collect,
    .date-return {
      margin-right: 0.5rem;
    }

    .break.dates {
      display: none;
    }
  }
}

@media screen and (min-width: 30em) {
  #cars {
    .options {
      display: flex;

      select {
        flex: 1;
        margin-right: 1rem;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .leg {
      display: flex;
      flex-wrap: wrap;
    }

    .datetime {
      display: flex;
    }
  }
}

@media screen and (min-width: 60em) {
  #cars {
    .options {
      select {
        flex: none;
      }
    }

    .picker,
    .datetime-collect {
      margin-right: 1rem;
    }

    .break {
      display: none;
    }

    .break-return {
      display: block;
    }

    .date-picker-return {
      margin-right: 0;
    }
  }
}
</style>
